import React from 'react';

import { useUserAuth } from '@/state/cookieContext';

import type { SidebarMenu } from '../types';
import { useSecondsoldManagementMenus } from './acloset-management';
import claimMenus from './claim';
import dashboardMenus from './dashboard';
import 설정_메뉴들 from './management/seller';
import useOrderMenus from './order';
import productMenus from './product';
import taskMenus from './upload/task';

/**
 * auth 기반으로 메뉴를 필터링합니다.
 */
export default function useFilteredMenuByAuthority(): SidebarMenu[] {
  const userAuth = useUserAuth();

  const { orderMenus } = useOrderMenus();
  const secondsoldManagementMenus = useSecondsoldManagementMenus();

  return React.useMemo(() => {
    if (userAuth?.roles == null) {
      return [];
    }

    const sidebarMenus: SidebarMenu[] = [
      ...dashboardMenus,
      ...taskMenus,
      ...productMenus,
      ...orderMenus,
      ...claimMenus,
      ...secondsoldManagementMenus,
      ...설정_메뉴들,
    ];

    return sidebarMenus.filter(sidebarMenu => {
      // 권한의 경우 배열의 크기가 작기 때문에 연산의 비용이 적음
      // 따라서 효율보다는 직관적으로 볼 수 있는 형태로 작성 (배열의 길이가 길어지면 Set 검토)
      return userAuth.roles.some(role => sidebarMenu.roles?.includes(role));
    });
  }, [orderMenus, secondsoldManagementMenus, userAuth?.roles]);
}
